import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbCardModule } from '@nebular/theme';
import { HistoricoCanaisComponent } from './historico-canais.component';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
	imports: [
		CommonModule,
		NbCardModule,
		PipesModule
	],
	declarations: [
		HistoricoCanaisComponent
	],
	exports: [
		HistoricoCanaisComponent
	],
})

export class HistoricoCanaisModule {}


// WEBPACK FOOTER //
// ./src/app/components/historico-canais/historico-canais.module.ts